import React from 'react';

const DashboardTable = ({ 
  columns = [], 
  data = [], 
  onActionClick,
  actionIcons = [],
  getCellContent = null,
  sortable = false,
  sortColumn = null,
  sortDirection = null,
  onSort = null,
  emptyMessage = 'No data available'
}) => {
  const getColumnKey = (col) => {
    return col.toLowerCase().replace(/\s+/g, '_');
  };

  const handleSort = (col) => {
    if (!sortable || !onSort || col === 'ACTION') return;
    
    const colKey = getColumnKey(col);
    let newDirection = 'asc';
    
    if (sortColumn === colKey) {
      // Toggle direction if clicking same column (like TableGrid)
      newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Default ascending when clicking new column (like TableGrid)
      newDirection = 'asc';
    }
    
    onSort(colKey, newDirection);
  };

  const getSortClass = (col) => {
    if (!sortable || col === 'ACTION') return '';
    const colKey = getColumnKey(col);
    const isActive = sortColumn === colKey;
    return isActive
      ? (sortDirection === 'asc' ? 'datatable-ascending' : 'datatable-descending')
      : '';
  };

  const renderCellContent = (col, row) => {
    if (getCellContent && typeof getCellContent === 'function') {
      const custom = getCellContent(col, row);
      if (custom != null) return custom;
    }

    const colKey = getColumnKey(col);
    
    if (col === 'ACTION' && actionIcons.length > 0) {
      return (
        <div className="d-flex">
          {actionIcons.map((icon, iconIndex) => (
            <a
              key={iconIndex}
              className="btn btn-icon px-1 btn-transparent-dark"
              title={icon.title || "Detail view"}
              style={{ cursor: 'pointer' }}
              onClick={() => onActionClick && onActionClick(row, icon.action)}
            >
              {icon.svg}
            </a>
          ))}
        </div>
      );
    }
    
    if (col === 'STATUS' && row.statusClass) {
      return (
        <span className={`badge ${row.statusClass}`}>{row[colKey] || row.status}</span>
      );
    }
    
    // Add DOT indicator for TYPE column if it's a DOT exam
    if (col === 'TYPE') {
      const typeValue = row[colKey] || row[col.toLowerCase()] || '';
      if (row.is_dot) {
        return (
          <span>
            {typeValue}
            <span className="badge badge-info ml-2" style={{ fontSize: '0.7rem' }}>DOT</span>
          </span>
        );
      }
      return typeValue;
    }
    
    return row[colKey] || row[col.toLowerCase()] || '';
  };

  return (
    <div className="sh_dashtableoverflowtable">
      <table className="table dataTable sh_tablenew nowrap table-hover" width="100%" cellSpacing="0" style={{ width: '100%' }}>
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th
                key={index}
                scope="col"
                className={getSortClass(col)}
                style={sortable && col !== 'ACTION' ? { cursor: 'pointer', userSelect: 'none', verticalAlign: 'middle' } : {}}
                onClick={() => handleSort(col)}
              >
                {sortable && col !== 'ACTION' ? (
                  <a href="#!" className="datatable-sorter" onClick={(e) => e.preventDefault()}>
                    {col}
                  </a>
                ) : (
                  col
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center py-3">
                <span>{emptyMessage}</span>
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <td key={colIndex} className="forTable_textEllipsis">
                    {renderCellContent(col, row)}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DashboardTable;

